<template>
<div>
  <hr v-if="!isHeader" class="section-line">
  <v-row no-gutters class="px-1 pt-2 pb-0">
    <v-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :cols="12">
      <v-row no-gutters>
        <slot>
        <!-- 任意設定エリア -->
        </slot>
      </v-row>
    </v-col>
    <v-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :cols="12">
      <v-row no-gutters :justify="buttonPosition">
        <v-chip
          v-if="copyMode"
          label
          color="cyan"
          text-color="white"
        >
          <v-icon left>
            mdi-file-replace-outline
          </v-icon>
          複写作成中
        </v-chip>
        <dd-transparent-button
          v-if="isDeleteButtonDisplay"
          :minWidth="70"
          @click="onDeleteButtonClick"
          :tooltipText="`表示している${functionName}を削除します。削除後は戻せませんのでご注意下さい。`"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
          削除
        </dd-transparent-button>
        <dd-transparent-button
          v-if="isCopyButtonDisplay"
          :minWidth="70"
          @click="onCopyButtonClick"
          :tooltipText="`表示している内容そのままに新規登録用に切り替えます。<br>同じような${functionName}作成の場合に使用すると便利です。`"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
        >
          <v-icon>mdi-content-copy</v-icon>
          複製
        </dd-transparent-button>
        <dd-transparent-button
          v-if="isNewButtonDisplay"
          :minWidth="70"
          @click="onNewButtonClick"
          tooltipText="現在の編集を破棄して新規登録用に切り替えます。"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
        >
          <v-icon>mdi-plus-circle-outline</v-icon>
          新規
        </dd-transparent-button>
        <dd-transparent-button
          :minWidth="abbreviatedDisplay ? 70 : 160"
          @click="onCancelButtonClick"
          :tooltipText="`ダイアログを開いた時の内容に戻します。入力間違いなどを戻したい場合に使用して下さい。<br>※但し、保存後は保存した時の内容になります。`"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
        >
          <v-icon>mdi-restore</v-icon>
          <span v-if="!abbreviatedDisplay">前回の保存状態に戻す</span>
          <span v-else>戻す</span>
        </dd-transparent-button>
        <dd-custom-button
          id="v-step-save"
          :rounded="true"
          :minWidth="180"
          @click="onSaveButtonClick"
        >
          保存する
        </dd-custom-button>
      </v-row>
    </v-col>
  </v-row>

  <hr v-if="isHeader" class="section-line">
</div>
</template>

<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import { mapGetters } from 'vuex'

export default {
  name: 'DdEditCommonBar',
  props: {
    /**
     * 画面タイトル
     */
    viewTitle: String,
    /**
     * 機能名
     */
    functionName: {
      type: String,
      default: 'データ'
    },
    /**
     * ヘッダー是非
     */
    isHeader: {
      type: Boolean,
      default: true
    },
    /**
     * 複写ボタン表示
     */
    isCopyButtonDisplay: {
      type: Boolean,
      default: false
    },
    /**
     * 削除ボタン表示
     */
    isDeleteButtonDisplay: {
      type: Boolean,
      default: false
    },
    /**
     * 新規ボタン表示
     */
    isNewButtonDisplay: {
      type: Boolean,
      default: false
    },
    /**
     * 複写モード
     */
    isCopyMode: {
      type: Boolean,
      default: false
    },
    /**
     * ボタン配置
     */
    buttonPosition: {
      type: String,
      default: 'end'
    },
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DdCustomButton,
    DdTransparentButton
  },
  data: () => ({
    copyMode: false
  }),
  computed: {
    ...mapGetters({
      helpUseFlg: 'DDMasters/helpUseFlg'
    })
  },
  watch: {
    isCopyMode: function (n) {
      this.copyMode = n
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onDeleteButtonClick: function () {
      this.$emit('delete')
    },
    onCopyButtonClick: function () {
      this.$emit('copy')
    },
    onCancelButtonClick: function () {
      this.$emit('cancel')
    },
    onNewButtonClick: function () {
      this.$emit('new')
    },
    onSaveButtonClick: function () {
      this.$emit('save')
    }
  }
}
</script>
